import { uniqueId } from 'lodash';

export const initalStateCriterio = () => ({
  $$id: uniqueId(),
  campo: null,
  excecao: false,
  values: null,
});

export const initialStateRegra = () => ({
  $$id: uniqueId(),
  criterios: [initalStateCriterio()],
  aprovadores: [],
  requerAprovacaoTotal: false,
});
